module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Semibold.2210dc889f01d79f545ebc6a8af853d0.woff2";